import autoload from "./autoload";
import auth from './mixins/auth';
import cart from './mixins/cart';
import initDom from './mixins/init_dom';
import knowledgeBaseList from './components/knowledge_base/knowledgeBaseList.vue';

autoload();

window.app = new Vue({
  el: '#vue-knowledge-base',
  mixins: [initDom, auth, cart],

  components: {
    knowledgeBaseList,
  },
});